import { observable, computed } from 'mobx'
import includes from 'lodash/includes'
import { Model } from 'libx'
import { getLogo } from 'misc/brokerLogos'

export default class LinkedAccount extends Model {
  @observable id
  // Can be 'plaid' or 'quovo'
  @observable provider
  @observable institution
}

const QUOVO_STATUS_NEEDS_USER_INTERACTION = [
  'login',
  'questions',
  'config'
]

export class QuovoLinkedAccount extends LinkedAccount {
  @observable status
  @observable brokerageId

  parse (json) {
    const { brokerage_name, brokerage, ...rest } = json
    return {
      ...rest,
      provider: 'quovo',
      brokerageId: brokerage,
      institution: brokerage_name
    }
  }

  @computed get syncing () {
    return this.status === 'syncing'
  }

  @computed get needsUserInteraction () {
    if (!this.status) {
      return true
    }

    return includes(QUOVO_STATUS_NEEDS_USER_INTERACTION, this.status)
  }

  @computed get logo () {
    return getLogo(this.brokerageId)
  }
}

export class PlaidLinkedAccount extends LinkedAccount {
  @observable publicToken
}



// WEBPACK FOOTER //
// ./src/client/domain/LinkedAccount.js